/*
    环境地址配置页面
*/
// 环境类别   1.本地  2.测试   3.线上
let type = 3
let searchUrl = ""
let liveUrl = ""
let socketUrl = ""
let socketUrlDan = ""
if (process.env.VUE_APP_CURRENTMODE == 'dev') {
    type = 2
}
if (process.env.VUE_APP_CURRENTMODE == 'prod') {
    type = 3
}
if (type == 1) {
    // 本地服务
    searchUrl = 'http://192.168.1.92:8106'  //联调振宇的地址
} else if (type == 2) {
    // 测试服务
    searchUrl = 'http://47.121.127.185:20315'  //测试
} else {
    // 线上环境服务
    searchUrl = 'https://cr.51xueshuo.com'
}
const url = {
    searchUrl,
    liveUrl,
    socketUrl,
    type,
    socketUrlDan
}
export default url
